import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Box, Typography, CircularProgress, Alert } from "@mui/material";
import api from "services/api";
import dayjs from "dayjs";
import { IMissingDataTableItem, IMissingDataResponse } from './types';
import { TableView } from './Table';
import { Main } from "./styled";

export function Tables() {
  const { workspaceId } = useParams() as { workspaceId: string };

  const { data, isFetching, isFetched, isError, error } = useQuery({
    queryKey: ["missingDataTables", workspaceId],
    queryFn: () => api.get(`/v2/missing-data/${workspaceId}/history`),
    select: (response) => response.data.data as IMissingDataResponse,
    retry: (failureCount, error: any) => {
      // Don't retry on 404 (workspace not found) or 403 (no permission)
      if (error?.response?.status === 404 || error?.response?.status === 403) {
        return false;
      }
      // Retry up to 2 times for other errors
      return failureCount < 2;
    },
  });

  const getErrorMessage = () => {
    if (!error) return "Erro desconhecido";
    
    const errorResponse = (error as any)?.response;
    if (errorResponse?.status === 404) {
      return "Workspace não encontrado ou sem permissão de acesso";
    }
    if (errorResponse?.status === 403) {
      return "Sem permissão para acessar este workspace";
    }
    if (errorResponse?.status >= 500) {
      return "Erro interno do servidor. Tente novamente em alguns minutos";
    }
    
    return "Erro ao carregar dados. Verifique sua conexão e tente novamente";
  };

  return (
    <>
      {!isFetched && isFetching && (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Carregando dados...</Typography>
        </Box>
      )}
      
      {!isFetched && isError && (
        <Alert severity="error">
          {getErrorMessage()}
        </Alert>
      )}
      {data && data.people && data.people.length === 0 && (
        <Alert severity="info">
          Nenhum dado encontrado para este workspace.
        </Alert>
      )}
      {data && data.people && Array.isArray(data.people) && data.people.length > 0 && (
        <>
          <h6 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Dados capturados de campanha</h6>
          <TableView data={data.people} />
        </>
      )}
    </>
  )
}